import {
  BoxAction,
  FlexSpaceDetectionParams,
  OosDetectionParams,
  ProduceVisionIssues,
  ProduceVisionParams,
  Store,
} from './types';
import { getVersionInfo } from './utils/version';

export const appVersion = getVersionInfo();

export const getProcessingTypeColor = (type: string): string => {
  switch (type) {
    case 'structured':
      return 'bg-blue-100 text-blue-800';
    case 'flex-space':
      return 'bg-green-100 text-green-800';
    case 'structured-produce':
      return 'bg-purple-100 text-purple-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleString('en-US');
};

export const getUniqueChains = (stores: Store[]): { label: string; value: string }[] => {
  return stores
    .map((store) => ({
      label: store.chainLegibleName,
      value: store.chainName,
    }))
    .filter((value, index, self) => index === self.findIndex((t) => t.value === value.value));
};

export const getOosDetections = (
  actions: BoxAction[]
): {
  tagName: string;
  params: OosDetectionParams;
}[] =>
  Object.entries(
    actions.reduce(
      (acc, action) => {
        if (!action.oosDetection) {
          return acc;
        }
        const tagName = action.tagName;
        if (!acc[tagName]) {
          acc[tagName] = {
            detections: [],
          };
        }
        acc[tagName].detections.push({
          product_id: action.productId,
          ...(!action.productId && { upc: action.upc }),
          state: action.oosDetection,
        });
        return acc;
      },
      {} as Record<string, OosDetectionParams>
    )
  ).map(([tagName, params]) => ({
    tagName,
    params,
  }));

export const getFlexSpaceDetections = (
  actions: BoxAction[],
  imageId: number
): {
  tagName: string;
  params: FlexSpaceDetectionParams;
}[] => {
  // TODO: Implement logic to extract flex space detections
  return [];
};

// export const getCoffeeDetections = (
//   actions: BoxAction[],
//   imageId: number
// ): null | {
//   params: CoffeeDetectionParams;
// } => {
//   // TODO: Implement logic to extract coffee detections

//   const coffeeActions = actions.filter(
//     (action) => action.mod.processing_type === 'coffee-machine'
//   );
//   if (coffeeActions.length === 0) {
//     return null;
//   }

//   return null;
// };

export const getProduceActions = (actions: BoxAction[]): BoxAction[] => {
  return actions.filter((action) => action.produceIssue || action.occupancy != null);
};

export const getProduceVision = (
  actions: BoxAction[],
  imageId: number
): null | {
  params: ProduceVisionParams;
} => {
  const produceActions = getProduceActions(actions);

  if (produceActions.length === 0) {
    return null;
  }
  return {
    params: {
      image_id: imageId,
      boxes_info: produceActions.map((action) => ({
        bbox_id: action.bboxId,
        commodity_found: action.commodityFound ?? [DEFAULT_COMMODITY_FOUND],
        expected_commodity: action.expectedCommodity ?? DEFAULT_COMMODITY,
        issues: action.produceIssue ? (PRODUCE_VISION_ISSUES[action.produceIssue] ?? []) : [],
        occupancy_area: action.occupancy ?? null,
      })),
    },
  };
};

export const DEFAULT_COMMODITY = 'Dragon Fruito Testo';
export const DEFAULT_COMMODITY_FOUND = 'Brocollo Testo';

const PRODUCE_VISION_ISSUES: Record<string, ProduceVisionIssues[]> = {
  presentability: [ProduceVisionIssues.MIXED],
  faceOver: [ProduceVisionIssues.POG_NONCOMPLIANT],
};
